/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Userroles1Inputs */

const en_entity_userroles1 = /** @type {(inputs: Entity_Userroles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Roles`)
};

const de_entity_userroles1 = /** @type {(inputs: Entity_Userroles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerrollen`)
};

/**
* | output |
* | --- |
* | "User Roles" |
*
* @param {Entity_Userroles1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_userroles1 = /** @type {((inputs?: Entity_Userroles1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Userroles1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_userroles1(inputs)
	return de_entity_userroles1(inputs)
});
export { entity_userroles1 as "entity_userRoles" }